export default __webpack_public_path__ + "static/how_it_work_4-ea30b0f0f807484ad75931be81574ee0.png";